import { FC } from "react";
import { useTranslation } from "next-i18next";
import {
  i18translateType,
  ServiceCardIconImageTopWithoutLinksType,
} from "../../@types/types-body";
import Image from "next/image";
import Link from "next/link";
import { AddressCard } from "@components/icons/address-card";

export const TeamCardIconImageTopWithoutLinks: FC<
  ServiceCardIconImageTopWithoutLinksType
> = ({ id, namespace, text, name, position, photo, link, cssPosition }) => {
  const { t }: i18translateType = useTranslation(namespace);
  return (
    <div
      className="group mb-12 relative transition-all drop-shadow-[10px_10px_20px_rgba(0,0,0,0.15)] rounded-[20px] skew-left
            ease-in-out delay-150 hover:-translate-y-2 hover: hover:scale-120 hover:shadow-2xl duration-300 hover:border-0"
      key={`service-card-for-${id}`}
    >
      <div className="flex flex-col flex-wrap justify-between relative rounded-t-xl h-full md:w-80 lg:w-96">
        <div className="rounded-t-xl w-72 h-72 lg:h-80 lg:w-80 mx-auto">
          <Image
            src={photo}
            className={`rounded-full object-cover grayscale group-hover:grayscale-0 h-80 ${cssPosition ? "object-top": "object-center"}`}
            fill={false}
            alt={t(`${name}`)}
          />
        </div>
        <div className="z-1 h-auto px-4 text-center ">
          <h3 className="mt-2 text-xl text-crowlyn-night">{t(`${name}`)}</h3>
          <p className="font-light text-sm text-crowlyn-light">
            {t(`${position}`)}
          </p>
          <p className="font-light text-base text-justify">{t(`${text}`)}</p>
          <div className="my-2">
            <Link href={t(`${link}`)}>
              <div
                className={"flex flex-row justify-center fill-crowlyn-light my-auto"}
              >
                <div className={"w-6 h-6 mr-2 my-auto"}>{AddressCard}</div>
                {t("contact")}
              </div>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};
